/*
 * action types
 */
export const GET_NOTIFICATION_REQUEST = "GET_NOTIFICATION_REQUEST";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAILURE = "GET_NOTIFICATION_FAILURE";
export const UPDATE_NOTIFICATION_REQUEST = "UPDATE_NOTIFICATION_REQUEST";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAILURE = "UPDATE_NOTIFICATION_FAILURE";
export const UPDATE_NOTIFICATION_ITEMS_ID_REQUEST =
  "UPDATE_NOTIFICATION_ITEMS_ID_REQUEST";
export const UPDATE_NOTIFICATION_ITEMS_ID_SUCCESS =
  "UPDATE_NOTIFICATION_ITEMS_ID_SUCCESS";
export const UPDATE_NOTIFICATION_ITEMS_ID_FAILURE =
  "UPDATE_NOTIFICATION_ITEMS_ID_FAILURE";

/*
 * action creators
 */
export const getNotificationRequest = () => ({
  type: GET_NOTIFICATION_REQUEST
});

export const getNotificationSuccess = data => ({
  type: GET_NOTIFICATION_SUCCESS,
  data
});

export const getNotificationFailure = () => ({
  type: GET_NOTIFICATION_FAILURE
});

export const updateNotificationRequest = id => ({
  type: UPDATE_NOTIFICATION_REQUEST,
  id
});

export const updateNotificationSuccess = data => ({
  type: UPDATE_NOTIFICATION_SUCCESS,
  data
});

export const updateNotificationFailure = () => ({
  type: UPDATE_NOTIFICATION_FAILURE
});

export const updateNotificationItemsIDRequest = () => ({
  type: UPDATE_NOTIFICATION_ITEMS_ID_REQUEST
});

export const updateNotificationItemsIDSuccess = () => ({
  type: UPDATE_NOTIFICATION_ITEMS_ID_SUCCESS
});

export const updateNotificationItemsIDFailure = () => ({
  type: UPDATE_NOTIFICATION_ITEMS_ID_FAILURE
});



// WEBPACK FOOTER //
// ./src/actions/notification.js